/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbStadeGridDto
 */
export interface FcbStadeGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbStadeGridDto
     */
    idstade?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbStadeGridDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbStadeGridDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbStadeGridDto
     */
    actif?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbStadeGridDto
     */
    acquisIfapme?: boolean;
}

/**
 * Check if a given object implements the FcbStadeGridDto interface.
 */
export function instanceOfFcbStadeGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbStadeGridDtoFromJSON(json: any): FcbStadeGridDto {
    return FcbStadeGridDtoFromJSONTyped(json, false);
}

export function FcbStadeGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbStadeGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idstade': !exists(json, 'idstade') ? undefined : json['idstade'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
        'acquisIfapme': !exists(json, 'acquisIfapme') ? undefined : json['acquisIfapme'],
    };
}

export function FcbStadeGridDtoToJSON(value?: FcbStadeGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idstade': value.idstade,
        'code': value.code,
        'description': value.description,
        'actif': value.actif,
        'acquisIfapme': value.acquisIfapme,
    };
}

